// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-generator__title{padding:25px 10px 0;font-weight:bold;font-size:15px;text-align:center}.qrcode-generator__sub-title{padding:20px 30px 10px;text-align:center}.qrcode-generator__image-container{position:relative;min-height:400px;min-width:400px}.qrcode-generator__copy_link_wrapper{padding:0 10px;text-align:center}", ""]);
// Exports
module.exports = exports;
